import { Dispatch } from "redux/commonTypes";

import contactsApi from "./contactsApi";
import { buySuccessType, priceType } from "../purchase/purchaseTypes";
import { actionTypes } from "./contactsTypes";


const Actions = {
    setRestContacts: (contacts: number) => ({
      type: actionTypes.SET_REST_CONTACTS,
      payload: contacts
    }),
    setMessageStatus: (status: number | null) => ({
      type: actionTypes.SET_MESSAGE_STATUS,
      payload: status
    }),
    setMessageTrigger: (trigger: boolean) => ({
      type: actionTypes.SET_MESSAGE_TRIGGER,
      payload: trigger
    }),
    setContactsPricelist: (priceList: priceType[]) => ({
        type: actionTypes.SET_CONTACTS_PRICELIST,
        payload: priceList
    }),
    setBuyLoading: (status: boolean) => ({
      type: actionTypes.SET_BUY_LOADING,
      payload: status,
    }),
    setBuySuccess: (status: buySuccessType) => ({
      type: actionTypes.SET_BUY_SUCCESS,
      payload: status,
    }),
    getContactPrices: () => (dispatch: Dispatch) => {
      contactsApi
        .getContactsPriceList()
        .then((resp) => {
          resp.data.freePrice?.paymentFeature
            ? dispatch(
                Actions.setContactsPricelist([
                  ...resp.data.priceList,
                  {
                    ...resp.data.freePrice?.paymentFeature,
                    isFree: true,
                    coolDown: resp.data.freePrice?.timeAvailableActivation,
                  },
                ])
              )
            : dispatch(Actions.setContactsPricelist(resp.data.priceList));
        })
    },
    toggleContactMessage: (status: boolean) => ({
      type: actionTypes.TOGGLE_CONTACT_MESSAGE,
      payload: status
    }),
    buyContact: (id: number) => (dispatch: Dispatch) => {
      dispatch(Actions.setBuyLoading(true));
      contactsApi
        .buyContact(id)
        .then((response) => {
          dispatch(Actions.setBuyLoading(false));
          dispatch(Actions.setBuySuccess("Yes"));
        })
        .catch((error) => {
          dispatch(Actions.setBuyLoading(false));
          dispatch(Actions.setBuySuccess("No"));
        });
    }
};
  
export default Actions;

